import React from 'react'
import '../../../../PulsatingDot.css'

const PulsatingDot = () => <div className="pulsatingDot" />

export default PulsatingDot